export default __webpack_public_path__ + "static/media/Darshana Patel.8b93cb57.jpg";